// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"16f82106da01ecfd3c5a","134":"75f2da7e4815064450e6","135":"06c522faf0c10673ff00","182":"c19f83e12af8085fae3c"}[chunkId] + ".chunk.js";
};